



















import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import PageLayout from '@/pro/views/PageLayout.vue';
import BasicInfo from '@/pro/views/contents/product/basic/ProductAdd/basicInfo/BasicInfo.vue';
import {
  BasicInformation,
  BasicInformationModel,
  Content,
  DeliveryInformation,
  DeliveryInformationModel,
  EditFlag,
  ImageInformationModel,
  ImagesInformation,
  NaverShoppingEPInformation,
  ProductAddButtonType,
  RelatedProductInformation,
  SalesInformation,
  SalesInformationModel,
  VerifyProductInfoResult,
  MaxPurchaseType,
  MaxBuyCountInfoType,
} from '@/pro/types';
import {
  CONFIG_TYPE,
  CONTENT_TYPE,
  DELETE_ERROR,
  IMMUTABLE_TYPE,
  MAP_NAVER_PRODUCT_FLAG,
  PRODUCT_FORM_ERROR_TYPE,
  SORT_CRITERION,
} from '@/pro/const/contents/product';
import { pick, unescapeHtml } from '@/pro/utils/common';
import {
  GetProduct,
  NCPResponse,
  ProductType,
  StandardCategoriesTree,
  YorN,
  PostProducts,
  GetPartnersByPartnerNo,
} from 'supporter';
import { INITIAL_DIGIT } from '@/pro/components/product/ChangeDisplayOrder';
import { APPLY_STATUS, SALE_STATUS } from '@/pro/const/common';
import { PRODUCT_REGISTRATION_TYPE } from '@/pro/views/contents/product/basic/ProductRegistration.vue';
import {
  defaultBasicInfo,
  defaultDeliveryInfo,
  defaultExtraInfo,
  defaultImagesInfo,
  defaultNaverShoppingEPInfo,
  defaultRelatedProductInfo,
  defaultSalesInfo,
  getDefaultReservationInfo,
  getDefaultSalePeriodInfo,
  getNavBtns,
  immutableFields,
  navBtnClickEvent,
  threeMonths,
  today,
} from '@/pro/views/contents/product/basic/ProductAdd/ProductAdd';
import { namespace } from 'vuex-class';
import { throwBottomNavigation } from '@/pro/helpers/bottomNav';
import { CommissionType } from '@/pro/views/contents/product/basic/ProductAdd/salesInfo/calculator/SalesInfoCalculator';
import { Admin } from '@/types';
import RelatedProduct from '@/pro/views/contents/product/basic/ProductAdd/basicInfo/details/RelatedProduct.vue';
import SalesInfo from '@/pro/views/contents/product/basic/ProductAdd/salesInfo/SalesInfo.vue';
import ImagesInfo from '@/pro/views/contents/product/basic/ProductAdd/imagesInfo/ImagesInfo.vue';
import DeliveryInfo from '@/pro/views/contents/product/basic/ProductAdd/deliveryInfo/DeliveryInfo.vue';

const MANAGEMENT_TYPE = {
  edit: 'edit',
  copy: 'copy',
} as const;

export type ProductRegistrationType = keyof typeof PRODUCT_REGISTRATION_TYPE;
export interface QueryType {
  mallProductNo: string;
  type: ProductRegistrationType;
}
export type SalesInfoRefModel = Pick<BasicInformation, 'mallNo' | 'categoryNo' | 'productName' | 'saleMethodType'> &
  Pick<DeliveryInformation, 'deliveryTemplateNo'> & {
    productNo: number;
    standardCategoryCommission: number;
    isSelectedMall: boolean;
  };
export interface ProductManagementMode {
  isMapping: boolean;
  isEdit: boolean;
  isCopy: boolean;
  isCopyWithStockMode: boolean;
  isNotOriginMall: boolean;
}

const adminStore = namespace('admin');

@Component({
  components: { RelatedProduct, BasicInfo, SalesInfo, ImagesInfo, DeliveryInfo, PageLayout },
})
export default class ProductAdd extends Vue {
  @Prop({ required: true })
  private readonly title: string;

  @adminStore.Getter('admin')
  private stateAdmin!: Admin;

  private isForAdults = false;
  private partnerName = '';
  private maxPurchaseType: MaxPurchaseType = 'maxBuyTimeCnt';

  private readonly MAP_NAVER_PRODUCT_FLAG = MAP_NAVER_PRODUCT_FLAG();

  private get productNo(): number {
    const productNo = this.isCopyMode ? Number(this.$route.query.parentNo) : Number(this.$route.params.productNo);
    return isNaN(productNo) ? 0 : productNo;
  }

  private get path(): string {
    return this.$route.path;
  }

  private get isEditMode(): boolean {
    return this.path.includes(MANAGEMENT_TYPE.edit);
  }

  private get isCopyMode(): boolean {
    return this.path.includes(MANAGEMENT_TYPE.copy);
  }
  private get isCopyWithStockMode(): boolean {
    return this.isCopyMode && this.$route.query?.copyStockYn === 'Y';
  }
  private get isCopySyncStockMode(): boolean {
    return this.isCopyMode && this.$route.query?.synced === 'Y';
  }
  private get isCopyProhibitionMode(): boolean {
    return this.isCopyMode && this.editFlag.isProhibited;
  }
  private get isNotOriginMall(): boolean {
    // 복사 시 몰 변경 isNotOriginMall = true;
    return this.isCopyMode && this.$route.query?.originMallYn !== 'Y';
  }

  private get isDeepSea(): boolean {
    return this.basicInfoRef?.isDeepSea;
  }

  private resetCategoryData() {
    this.salesInfoRef.resetAllOriginCountry();
    this.salesInfoRef.resetCertification();
    this.basicInfoRef.resetMinorPurchase();
    this.isForAdults = false;
  }

  private get mode(): ProductManagementMode {
    return {
      isMapping: this.$route.query?.type === PRODUCT_REGISTRATION_TYPE.MAPPING,
      isEdit: this.isEditMode,
      isNotOriginMall: this.isNotOriginMall,
      isCopy: this.isCopyMode,
      isCopyWithStockMode: this.isCopyWithStockMode,
    };
  }

  private get isSelectedMall(): boolean {
    return this.basicInfo.mallNo > 0;
  }

  private async fetchPartnerNo() {
    if (!this.isSelectedMall) return;
    const { data } = await this.$api.getPartnersByPartnerNo({
      pathParams: { partnerNo: this.stateAdmin.partnerNo.toString() },
    });

    this.basicInfo.partnerNo = this.stateAdmin.partnerNo;
    this.partnerName = ((data as any) as GetPartnersByPartnerNo).partnerName;
    this.deliveryInfo.shippingAreaPartnerNo = this.stateAdmin.partnerNo;
  }

  // 기본정보
  // basic-info
  @Ref()
  private readonly basicInfoRef: BasicInfo;

  private basicInfo: BasicInformation = defaultBasicInfo();

  private get showRelatedProduct(): boolean {
    return this.relatedProductInfo.relatedProductInfo.configType === CONFIG_TYPE.SELECTED;
  }

  // TODO refactor
  private alertMallSelect() {
    this.verifyResultHandler({
      success: false,
      fail: { type: 'basic', name: 'mall', msg: 'PRO_PRODUCT_ADD_PLZ_SELECT_SHOPPING_MALL' },
    });
  }

  // TODO refactor
  private alertProductName() {
    this.verifyResultHandler({
      success: false,
      fail: { type: 'basic', name: 'productName', msg: 'PRO_PRODUCT_ADD_PLZ_INSERT_PRODUCT_NAME' },
    });
  }

  private resetBasicInformation(): void {
    const defaultMemberGradeDisplayInfo = { check: 'NONE', info: [] };
    const defaultDisplayOrder = {
      type: 'AUTO',
      automaticDisplayType: SORT_CRITERION.LATEST_REGISTER_DATE,
    };

    this.$set(this.basicInfo, 'adminNo', '');
    this.$set(this.basicInfo, 'displayCategoryNos', []);
    this.$set(this.basicInfo, 'memberGradeDisplayInfo', defaultMemberGradeDisplayInfo);
    this.$set(this.basicInfo, 'displayOrder', defaultDisplayOrder);
    this.$set(this.basicInfo, 'categoryNo', '');
    this.$set(this.basicInfo, 'brandName', '');
    this.$set(this.basicInfoModel, 'categoryNo', [INITIAL_DIGIT]);
    this.$set(this.basicInfoModel, 'memberGrades', '');
  }

  // 관련상품
  // related-product-info
  @Ref()
  private readonly relatedProductInfoRef: RelatedProduct;
  private relatedProductInfo: { relatedProductInfo: RelatedProductInformation } = defaultRelatedProductInfo();
  private setFinalRelatedProductsInfo() {
    this.relatedProductInfoRef?.setFinalRelatedProducts();
  }

  private resetRelatedProducts() {
    this.relatedProductInfo = defaultRelatedProductInfo();
  }

  // 판매정보
  // sales-info
  @Ref()
  private readonly salesInfoRef: any; // TODO

  private salesInfo: SalesInformation = defaultSalesInfo(false);

  private get salesInfoRefModel(): SalesInfoRefModel {
    const { mallNo, categoryNo, productName, saleMethodType } = this.basicInfo;
    return {
      mallNo,
      isSelectedMall: mallNo > 0,
      categoryNo,
      productNo: this.productNo,
      deliveryTemplateNo: this.deliveryInfo.deliveryTemplateNo,
      productName,
      saleMethodType,
      standardCategoryCommission: this.standardCategoryCommission,
    };
  }

  private getFilteredCategory(categories: StandardCategoriesTree[]): StandardCategoriesTree {
    return categories.filter(category => category.categoryNo === this.basicInfo.categoryNo)[0];
  }

  private getSelectedStandardCategory(): StandardCategoriesTree {
    const filtered = this.getFilteredCategory(this.standardCategoriesCache);
    return filtered ? filtered : this.getFilteredCategory(this.standardCategoriesCache.flatMap(tree => tree.child));
  }

  private get standardCategoryCommission(): number {
    const category = this.getSelectedStandardCategory();
    return category && category.commissionRate ? category.commissionRate : 0;
  }

  private standardCategoriesCache: StandardCategoriesTree[] = [];
  private async fetchStandardCategories(mallNo: number): Promise<void> {
    const { data } = await this.$api.getStandardCategoriesTree({
      params: { mallNo: mallNo.toString() },
    });

    this.standardCategoriesCache = data.tree.flatMap(tree => tree.child).flatMap(childTree => childTree.child);
  }

  private resetSalesInformation(): void {
    this.salesInfoRef.reset();
  }

  private setFinalSalesInfo(): void {
    if (this.salesInfo.buyInfo.min === 'N') {
      this.salesInfo.minBuyCnt = 0;
    }

    this.salesInfoRef.setFinalSalesInfo();
  }

  private focusOnStandardCategory(): void {
    this.basicInfoRef.onFocus('category');
  }

  private alertDeliveryTemplate() {
    this.deliveryInfoRef.alertDeliveryTemplate();
  }

  // 이미지정보
  // images-info
  @Ref()
  private readonly imagesInfoRef: any; // TODO
  private imagesInfo: ImagesInformation = defaultImagesInfo();

  private resetImagesInformation(): void {
    this.imagesInfo.productGuides = [];
    this.imagesInfo.guideUseStatus = {};
    this.imagesInfoModel.productGuides = null;
    this.imagesInfoRef.resetImagesInfo();
  }

  private setFinalImagesInfo(): void {
    this.imagesInfoRef.setFinalImagesInfo();
  }

  private imagesInfoModel: ImageInformationModel = {
    contents: null,
    productGuides: null,
  };

  // 배송정보
  // delivery-info
  @Ref()
  private readonly deliveryInfoRef: any; // TODO

  private deliveryInfo: DeliveryInformation = defaultDeliveryInfo();

  private resetDeliveryInformation(): void {
    if (this.deliveryInfo.deliveryTemplateNo) return;
    this.deliveryInfo = defaultDeliveryInfo();
  }

  private deliveryInfoModel: DeliveryInformationModel = {
    deliveryTemplateNo: null,
  };

  // naver-shoppin-ep-info
  private naverShoppingEPInfo: NaverShoppingEPInformation = defaultNaverShoppingEPInfo();

  private resetNaverShoppingEPInformation(): void {
    this.naverShoppingEPInfo = defaultNaverShoppingEPInfo();
  }

  /*
   * 몰 변경 시 초기화 항목
   * 전시카테고리, 담당자, 회원등급, 관련상품, 아이콘, 안내템플릿, 배송비템플릿
   * 표준카테고리, 브랜드
   * */
  private async changedMall(mallNo: number) {
    await this.fetchPartnerNo();
    this.generateQueryStringByProductTypeForLnb();
    // 프로몰이 하나 이면 수정/복제 할때 changedMall이 호출된 후 resetBasicInformation()이 호출되어
    // 담당자, 표준카테고리가 초기화 된다.
    if (this.mode.isCopy || this.mode.isEdit) return;
    this.$nextTick(() => {
      this.resetBasicInformation();
      this.resetRelatedProducts();
      this.resetSalesInformation();
      this.resetImagesInformation();
      this.resetDeliveryInformation();
      this.resetNaverShoppingEPInformation();
      this.fetchPartnerNo();
      this.fetchStandardCategories(mallNo);
    });
  }

  private created() {
    this.init();
  }

  private mounted() {
    window.scrollTo(0, 0);
  }

  private async init() {
    // 쇼핑몰 선택 변경되어야 해서 주석처리
    // this.generateQueryStringByProductTypeForLnb();
    this.setProductDefaultInfo();
    await this.fetchProductInfo();
    await this.fetchPartnerNo();
    await this.fetchImmutableFields();
    this.setBottomNavigator();
  }

  private generateQueryStringByProductTypeForLnb(
    mallProductNo = 0,
    productType: ProductType = null,
    synced = false,
    masterNo = -1,
  ) {
    if (this.$route.name === 'CopyProduct') return;

    const productNo = mallProductNo === 0 ? this.$route.query.mallProductNo : mallProductNo;
    const parentNo = masterNo === -1 ? Number(this.$route.query?.parentNo) : masterNo;
    const type = productType === null ? this.$route.query.type : productType;

    this.$router
      .replace({
        query: {
          mallProductNo: productNo?.toString(),
          parentNo: isNaN(parentNo) ? '0' : parentNo.toString(),
          type,
          synced: synced ? 'Y' : 'N',
        },
      })
      .catch(() => null);
  }

  private setProductDefaultInfo() {
    this.salesInfo = defaultSalesInfo(this.editFlag.isMapping);
  }

  private editFlag: EditFlag = {
    isMapping: false, // 세트상품
    isReady: true,
    isApproved: false, // 승인완료
    isEnded: false, // 판매종료
    isMaster: true,
    isSynced: false, // 재고연동 여부 (slave)
    isSlave: false,
    isProhibited: false,
  };

  private setEditFlags({ productType, applyStatusType, saleStatusType, parentNo, synced, saleSettingStatusType }) {
    if (!this.isEditMode && !this.isCopyMode) return;
    this.editFlag.isMapping = productType === PRODUCT_REGISTRATION_TYPE.MAPPING;
    this.editFlag.isReady = productType === APPLY_STATUS.APPROVAL_READY;
    this.editFlag.isApproved = applyStatusType === APPLY_STATUS.FINISHED;
    this.editFlag.isEnded = saleStatusType === SALE_STATUS.END_SALE;
    this.editFlag.isMaster = !parentNo && synced;
    this.editFlag.isSynced = this.isCopyMode ? this.isCopyWithStockMode : synced;
    this.editFlag.isSlave = this.isCopyMode ? this.isCopyWithStockMode : parentNo > 0 && synced; // slave
    this.editFlag.isProhibited = this.isEditMode && saleSettingStatusType === 'PROHIBITION_SALE';
  }

  private productInfoCache = {} as GetProduct;
  // 수정/복사 시 상품번호로 상품정보 조회
  private async fetchProductInfo() {
    if (this.productNo === 0) return;

    const { data }: NCPResponse<GetProduct> = await this.$api.getProductByNo({
      params: { mallProductNo: this.productNo },
    });

    this.tempSave = data.saleSettingStatusType !== 'PROHIBITION_SALE';
    this.generateQueryStringByProductTypeForLnb(
      data.mallProductNo,
      data.productType as ProductType,
      data.synced,
      data.parentNo,
    );
    this.setEditFlags(data);

    this.productInfoCache = Object.assign({}, this.productInfoCache, data);

    await this.mapProductInfoByInfoType();
  }

  private extraInfo = defaultExtraInfo();
  private async mapProductInfoByInfoType() {
    const infoKeys = ['basic', 'relatedProduct', 'sales', 'images', 'delivery', 'naverShoppingEP', 'extra'];
    const setProduct = key => {
      const infoKey = `${key}Info`;
      const prevInfo = this[infoKey];
      const pickedInfo = pick<GetProduct, BasicInformation>(this.productInfoCache, Object.keys(prevInfo));
      this[infoKey] = {
        ...prevInfo,
        ...pickedInfo,
      };
    };
    await infoKeys.forEach(setProduct);
    this.initializeProductEditInfo();
  }

  /*
   * post/put products requestBody 와 화면에 출력되는 값의 형태가 다른 경우 @@@Model 객체로 관리
   * @@@Model = 화면 출력을 위한 값
   * @@@Info = requestBody 로 사용하기 위한 값
   * */
  private basicInfoModel: BasicInformationModel = {
    productName: '',
    productDesc: '',
    categoryNo: [INITIAL_DIGIT],
    keywords: '',
    memberGrades: '',
  };

  private salesInfoModel: SalesInformationModel = {
    isOverReservationSale: false,
    immediateRate: 0,
    supplyPrice: 0,
    defaultCommissionType: null,
    defaultCommissionRate: null,
    hasOptionImage: false,
    optionUseYn: 'N',
    useOption: false,
    useTextOption: false,
  };

  private initializeMemberGrades(info?: number[]) {
    if (this.$route.query.originMallYn === 'N') {
      this.basicInfo.memberGradeDisplayInfo.info = [];
      this.basicInfo.memberGradeDisplayInfo.check = 'NONE';
      this.basicInfoModel.memberGrades = '';
      return;
    }
    const infos: number[] = info?.length > 0 ? info : this.productInfoCache.memberGradeDisplayInfo.info;
    this.basicInfoModel.memberGrades = infos.join(',');
  }
  private setBasicInfoBy({
    productName,
    promotionTextInfo,
    categoryNo,
    keywords,
    displayCategoryNos,
    shortenUrl,
    extraJson,
  }: GetProduct) {
    this.basicInfo.mallNo =
      this.mode.isNotOriginMall || this.isCopyProhibitionMode
        ? Number(this.$route.query.mallNo)
        : this.productInfoCache.mallNo;
    this.basicInfo.adminNo =
      this.mode.isNotOriginMall || this.isCopyProhibitionMode ? '' : this.productInfoCache.adminNo;
    this.basicInfo.displayCategoryNos =
      this.mode.isNotOriginMall || this.isCopyProhibitionMode ? [] : displayCategoryNos;
    this.basicInfo.productDescInfo.startYmd = promotionTextInfo.startYmd ?? today;
    this.basicInfo.productDescInfo.endYmd = promotionTextInfo.endYmd ?? threeMonths;
    this.basicInfo.productDescInfo.text = promotionTextInfo.text ?? '';
    this.basicInfo.productDescInfo.useYn = promotionTextInfo.text ? 'Y' : 'N';
    this.basicInfo.productDescInfo.periodYn = promotionTextInfo.periodYn === 'Y';
    this.basicInfo.urlShorteningYn = shortenUrl ? 'Y' : 'N';

    // 모바일앱 현재 쓰지않으므로 setBasicInfo 할때 N 으로 데이터 보정
    this.basicInfo.platformDisplayInfo.mobileYn = 'N';

    // 'Y' 네이버페이 결제불가
    this.basicInfo.extraJson.naverPayLimitYn = extraJson.naverPayLimitYn === 'Y';

    this.basicInfoModel.productName = unescapeHtml(productName);
    this.basicInfoModel.productDesc = unescapeHtml(promotionTextInfo.text);
    this.basicInfoModel.categoryNo = this.isCopyProhibitionMode ? [INITIAL_DIGIT] : [categoryNo];
    this.basicInfoModel.keywords = keywords
      .map(keyword => keyword.trim())
      .filter(Boolean)
      .join(',');
    this.initializeMemberGrades();

    if (this.isNotOriginMall || this.isCopyProhibitionMode) {
      this.basicInfo.displayOrder = {
        type: 'AUTO',
        automaticDisplayType: SORT_CRITERION.LATEST_REGISTER_DATE,
      };
      this.relatedProductInfo = defaultRelatedProductInfo();
      this.salesInfo.stickerInfos = [];
    }
  }

  private resetByMallNo() {
    console.log('전시카테고리, 회원등급 노출 설정, 관련상품 설정, 아이콘, 안내들 초기화');
    console.log('담당자도 초기화 시켰음');
  }

  private setSalesInfoBy({ supplierProductName, productStockCnt }: GetProduct) {
    this.fetchStandardCategories(this.productInfoCache.mallNo);
    this.salesInfo.productStockCnt = productStockCnt;
    this.salesInfo.optionUseYn = this.salesInfo.options.length > 0 ? 'Y' : 'N';
    this.salesInfo.reservationInfoModel = { ...this.productInfoCache.reservationInfo };
    this.salesInfo.useReservation = this.productInfoCache.reservationInfo !== null;
    if (this.productInfoCache.dutyContent?.contents.length > 0) {
      this.salesInfo.dutyInfo.dutyContent = this.productInfoCache.dutyContent;
      this.salesInfo.dutyInfo.willDutyContent = this.productInfoCache.willDutyContent;
    }
    this.salesInfo.buyerProductName = supplierProductName;
    this.salesInfo.contentsIfPausing = this.productInfoCache.extraJson.contentsIfPausing;
    this.salesInfo.useContentsIfPausing = !!this.productInfoCache.extraJson.contentsIfPausing;
    this.salesInfo.salePrice = this.productInfoCache.salePrice;
    this.salesInfo.purchasePrice = this.productInfoCache.purchasePrice;
    this.salesInfo.accumulationRate = this.productInfoCache.accumulationRate;
    this.salesInfo.accumulationSaveYn = this.productInfoCache.accumulationRate === null ? 'N' : 'Y';
    this.salesInfo.buyInfo.min = this.salesInfo.minBuyCnt ? 'Y' : 'N';

    this.iterateMaxBuyCountInfo((property: MaxPurchaseType) => {
      if (this.salesInfo.maxBuyCountInfo[property]) {
        this.salesInfo.buyInfo.max = 'Y';
        this.maxPurchaseType = property === 'maxBuyPeriodCnt' ? 'maxBuyDays' : property;
      }
    });

    this.salesInfoModel.defaultCommissionType = this.productInfoCache.commissionInfo.type;
    this.salesInfoModel.defaultCommissionRate = this.productInfoCache.commissionInfo.rate;
    this.salesInfoModel.supplyPrice = this.productInfoCache.purchasePrice;
    this.salesInfoModel.immediateRate = this.productInfoCache.immediateDiscountInfo.amount;
    this.salesInfoRef.initializeSalesInfo();

    this.salesInfoModel.useOption = this.productInfoCache.optionUseYn === 'Y';
    this.salesInfoModel.useTextOption = this.productInfoCache.customerDemands.length > 0;
    this.salesInfoModel.optionUseYn =
      this.productInfoCache.optionUseYn === 'Y' || this.productInfoCache.customerDemands.length > 0 ? 'Y' : 'N';

    // 복사
    if (this.mode.isCopy) {
      this.salesInfo.reservationInfoModel = {
        ...getDefaultReservationInfo(),
        stockCnt: this.salesInfo.reservationInfoModel.stockCnt,
      };

      this.salesInfo.salePeriodInfo = getDefaultSalePeriodInfo(
        this.salesInfo.salePeriodInfo.periodType,
        this.productInfoCache.salePeriodInfo.endYmdt,
      );

      if (this.mode.isNotOriginMall || this.isCopyProhibitionMode) {
        this.resetByMallNo();
      }

      if (!this.mode.isCopyWithStockMode) {
        this.salesInfo.productStockCnt = 0;
        this.salesInfo.reservationInfoModel.stockCnt = 0;
      }
    }
  }

  private setImagesInfoBy({ content, contentHeader, contentFooter, addOptionImageYn, productGuides }: GetProduct) {
    this.imagesInfoModel.contents = {
      [CONTENT_TYPE.HEADER]: contentHeader,
      [CONTENT_TYPE.BODY]: content,
      [CONTENT_TYPE.FOOTER]: contentFooter,
      addOptionImageYn: addOptionImageYn as YorN,
    } as Content;
    this.imagesInfoModel.productGuides = this.isNotOriginMall || this.isCopyProhibitionMode ? [] : productGuides;
  }

  private setNaverShoppingEPInfoBy({ extraJson }) {
    if (!extraJson?.naverExtra) return;
    const naverExtra = JSON.parse(extraJson.naverExtra);
    this.naverShoppingEPInfo.naverShoppingEP = {
      ...extraJson,
      naverProductFlag: this.MAP_NAVER_PRODUCT_FLAG[extraJson.naverProductFlag] ?? null,
      naverExtra,
    };
  }

  // 조회된 상품 값으로 초기화
  private initializeProductEditInfo() {
    this.setBasicInfoBy(this.productInfoCache);
    this.setSalesInfoBy(this.productInfoCache);
    this.setImagesInfoBy(this.productInfoCache);
    this.setNaverShoppingEPInfoBy(this.productInfoCache);

    this.deliveryInfoModel.deliveryTemplateNo = this.productInfoCache.deliveryTemplateNo;
  }

  private immutableFields = [];

  // 하단 버튼
  private tempSave = false;
  private setBottomNavigator() {
    throwBottomNavigation({
      buttons: getNavBtns(
        this.isCopyMode || this.$route.path.includes('add') || this.tempSave,
        !this.editFlag.isProhibited,
      ),
      onClick: (navType: ProductAddButtonType) => {
        const navigator = navBtnClickEvent();
        switch (navType) {
          case 'tempSave':
            this.tempSave = true;
            break;
          case 'save':
            this.tempSave = false;
            break;
          case 'list':
            this.goToListPage();
            return;
        }
        this.verifyProductInformation(navigator);
      },
    });
  }

  // 저장 전 최종 검증
  private setFinalProductInfo() {
    this.setFinalRelatedProductsInfo();
    this.setFinalSalesInfo();
    this.setFinalImagesInfo();
  }
  private verifyProductInformation(navigator): void {
    this.setFinalProductInfo();
    this.verifyResultHandler(
      navigator.verifyProductInfo({
        basicInfo: this.basicInfo,
        salesInfo: this.salesInfo,
        imagesInfo: this.imagesInfo,
        deliveryInfo: this.deliveryInfo,
        hasOptionImage: this.salesInfoModel.hasOptionImage,
        optionUseYn: this.salesInfoModel.optionUseYn,
      }),
    );
  }

  private verifyResultHandler(verifyResult: VerifyProductInfoResult) {
    const { success, fail } = verifyResult;
    if (!success) {
      alert(this.$t(fail.msg).toString());
      this[`${fail.type}InfoRef`].onFocus(fail.name, fail['sub-type']);
      return;
    }
    this.requestHandler();
  }

  // 일반상품등록
  private postProduct(data: PostProducts) {
    this.$api
      .postProducts({ data })
      .then(ret => {
        alert(`${ret.data} 저장되었습니다.`);
        this.goToListPage();
      })
      .catch(this.handleError);
  }

  // 일반상품수정
  private putProduct(data: any) {
    this.$api
      .putProductByNo({
        params: {
          mallProductNo: this.basicInfo.mallProductNo,
        },
        data,
      })
      .then(res => {
        alert(`${res.data} 수정되었습니다.`);
        this.goToListPage();
      })
      .catch(this.handleError);
  }

  // 일반상품복사
  private copyProduct(data: any) {
    if (!this.$route.query.synced || this.$route.query.synced === 'N') {
      this.postProduct(data);
      return;
    }
    // 재고연동하여 등록 시
    this.$api
      .postProductsByMallProductNo({
        params: {
          mallProductNo: this.productNo.toString(),
          copyReview: this.$route.query.copyReviewYn === 'Y',
        },
        data,
      })
      .then(res => {
        alert(`${res.data} 저장되었습니다.`);
        this.goToListPage();
      })
      .catch(this.handleError);
  }

  private generateNaverShoppingInfo(extraJson) {
    const { naverShoppingEP } = this.naverShoppingEPInfo;
    const { naverExtra } = naverShoppingEP;

    const convertedNaverExtra = {};
    for (const key in naverExtra) {
      convertedNaverExtra[key] = naverExtra[key].toString();
    }

    let naverProductFlag = null;
    for (const key in this.MAP_NAVER_PRODUCT_FLAG) {
      if (this.MAP_NAVER_PRODUCT_FLAG[key] === naverShoppingEP.naverProductFlag) {
        naverProductFlag = key;
      }
    }
    return {
      ...extraJson,
      ...naverShoppingEP,
      naverProductFlag,
      naverExtra: JSON.stringify(convertedNaverExtra),
    };
  }

  private mapBasicInfoToBodyRequest() {
    const data = { ...this.basicInfo } as any;
    if (this.basicInfo.productDescInfo.useYn === 'N') return data;

    const { useYn, startYmd, endYmd, periodYn, text } = this.basicInfo.productDescInfo;
    data.promotionTextUseYn = useYn;

    if (!periodYn) {
      data.promotionTextInfo = {
        text,
        periodYn: 'N',
      };
    } else {
      data.promotionTextInfo = {
        startYmd,
        endYmd,
        text,
        periodYn: 'Y',
      };
    }
    return data;
  }
  private mapRelatedInfoToBodyRequest() {
    const data = { ...this.relatedProductInfo } as any;
    const { relatedProductInfo } = this.relatedProductInfo;
    if (relatedProductInfo.configType === CONFIG_TYPE.NOT_USED) {
      data.relatedProductInfo = null;
    }
    return data;
  }
  private mapSalesInfoToBodyRequest() {
    const data = { ...this.salesInfo } as any;
    const {
      buyerProductName,
      placeOriginInfo,
      certificationInfo,
      dutyInfo,
      commissionInfo,
      optionUseYn,
      accumulationSaveYn,
      maxBuyCountInfo,
    } = this.salesInfo;

    const newMaxBuyCountInfo: MaxBuyCountInfoType = {};

    if (buyerProductName) {
      data.supplierProductName = buyerProductName;
    }
    if (!placeOriginInfo.placeOriginSeq) {
      data.placeOriginInfo = null;
    }
    if (certificationInfo.type === 'TARGET') {
      data.certificationInfo.data.forEach(({ certificationContents }, idx) => {
        data.certificationInfo.data[idx].certificationContents = certificationContents.filter(Boolean);
      });
    }
    if (dutyInfo.useYn === 'Y') {
      const { saveTitle } = data.dutyInfo;
      data.dutyInfo.saveTitle = saveTitle === '' ? null : saveTitle;
    } else {
      data.dutyInfo.dutyContent = null;
    }

    if (commissionInfo.type === CommissionType.PURCHASE) {
      data.commissionInfo.rate = '';
    }

    if (optionUseYn === 'N') {
      data.options = null;
      data.optionType = 'DEFAULT';
    }

    if (accumulationSaveYn === 'N') {
      data.accumulationRate = null;
    }

    if (this.salesInfo.buyInfo.max === 'Y') {
      this.iterateMaxBuyCountInfo((property: MaxPurchaseType) => {
        if (
          this.maxPurchaseType === 'maxBuyDays' &&
          (Number(maxBuyCountInfo.maxBuyDays) || Number(maxBuyCountInfo.maxBuyPeriodCnt))
        ) {
          newMaxBuyCountInfo.maxBuyDays = maxBuyCountInfo.maxBuyDays;
          newMaxBuyCountInfo.maxBuyPeriodCnt = maxBuyCountInfo.maxBuyPeriodCnt;
        }

        if (this.maxPurchaseType !== 'maxBuyDays' && this.maxPurchaseType === property && maxBuyCountInfo[property]) {
          newMaxBuyCountInfo[property] = maxBuyCountInfo[property];
        }
      });
    }

    data.maxBuyCountInfo = newMaxBuyCountInfo;

    data.immediateDiscountInfo.amount = this.salesInfoModel.immediateRate;
    return data;
  }
  private mapImagesInfoBodyRequest() {
    const data = { ...this.imagesInfo } as any;

    if (this.imagesInfo.mallProductImages.length === 0) {
      data.mallProductImages = null;
    }

    data.productGuides = data.productGuides.filter(Boolean);
    return data;
  }
  private mapDeliveryInfoBodyRequest() {
    return { ...this.deliveryInfo };
  }
  private mapExtraInfoBodyRequest() {
    const data = { ...this.extraInfo } as any;
    const { naverPayLimitYn } = this.basicInfo.extraJson;

    data.extraJson = {
      ...data.extraJson,
      ...this.generateNaverShoppingInfo(data.extraJson),
      naverPayLimitYn: naverPayLimitYn ? 'Y' : 'N',
      contentsIfPausing: null,
    };

    if (this.salesInfo.useContentsIfPausing) {
      data.extraJson.contentsIfPausing = this.salesInfo.contentsIfPausing;
    }
    return data;
  }
  private generateBodyRequest() {
    const request = {
      data: {
        ...this.mapBasicInfoToBodyRequest(),
        ...this.mapRelatedInfoToBodyRequest(),
        ...this.mapSalesInfoToBodyRequest(),
        ...this.mapImagesInfoBodyRequest(),
        ...this.mapDeliveryInfoBodyRequest(),
        ...this.mapExtraInfoBodyRequest(),
      },
    } as any;
    request.data.tempSave = this.tempSave;
    return request;
  }

  private requestHandler() {
    const request = this.generateBodyRequest();

    if (this.salesInfo.buyInfo.min === 'Y' && !Number(request.data.minBuyCnt)) {
      alert(this.$t('PRODUCT.ADD.PLEASE_INSERT_MIN_COUNT'));
      this.salesInfoRef.onFocus('minPurchase');
      return;
    }

    if (this.salesInfo.buyInfo.max === 'Y' && !Object.keys(request.data.maxBuyCountInfo).length) {
      alert(this.$t('PRODUCT.ADD.PLEASE_INSERT_MAX_COUNT'));
      return;
    }

    if (this.isCopyWithStockMode) {
      this.copyProduct(request.data);
      return;
    }

    if (this.isEditMode) {
      this.putProduct(request.data);
      return;
    }

    this.postProduct(request.data);
  }

  private goToListPage() {
    this.$router.push({ name: 'ProductList' });
  }

  // error
  private formError = {} as { [errorKey: string]: string };
  private formErrorType: typeof PRODUCT_FORM_ERROR_TYPE = PRODUCT_FORM_ERROR_TYPE;
  private deleteError: typeof DELETE_ERROR = DELETE_ERROR;

  /*
   * 인라인 에러메시지 삭제
   * */
  private deleteErrorHandler(fields: string | string[]) {
    if (Array.isArray(fields)) {
      fields.forEach(field => {
        this.$delete(this.formError, field);
      });
    } else {
      this.$delete(this.formError, fields);
    }
  }

  /**
   * { 에러코드: 메시지 } 형태로 변환
   */
  private convertErrorMessage(errorList: { propertyName: string; error: string; message: string }[]) {
    errorList.forEach(({ error, message }) => this.$set(this.formError, error, message));
  }

  private handleError(error) {
    const { status, data } = error;
    const { detail } = data;
    let isAdult = false;

    if (status !== 400 || !detail) return;

    if (Array.isArray(detail)) {
      isAdult = detail.some(
        item => item.propertyName === 'monorPurchaseYn' || item.propertyName === 'nonmemberPurchaseYn',
      );
    }

    if (isAdult) return alert(this.$t('PRODUCT_ADD_ADULT_CERTIFYCATION_CANNOT_MODIFY'));

    // Axios interceptor 에서 에러처리하는 경우
    if (!error.message && !error.result?.message) {
      alert('입력 불가한 항목이 있습니다. 다시확인해주세요.');
    }
    this.convertErrorMessage(detail);
    const generalErrorFields = [
      PRODUCT_FORM_ERROR_TYPE.INVALID_MALL_PRODUCT_NO,
      PRODUCT_FORM_ERROR_TYPE.INVALID_PARENT_PRODUCT_NO,
      PRODUCT_FORM_ERROR_TYPE.NON_EDITABLE_PRODUCT,
      PRODUCT_FORM_ERROR_TYPE.NON_EDITABLE_MALL_NO,
    ];
    generalErrorFields.forEach(error => {
      if (Object.keys(detail).includes(error)) {
        alert(detail[error]);
      }
    });
  }

  private fetchImmutableFields() {
    this.tempSave = true;

    if (this.$route.path.includes('add')) return;

    if (this.isCopySyncStockMode) {
      this.immutableFields = immutableFields(IMMUTABLE_TYPE.COPY, IMMUTABLE_TYPE.SYNC);
      return;
    }

    this.tempSave = false;
    let immutableType = null;

    if (this.editFlag.isSlave || this.editFlag.isSynced) {
      immutableType = IMMUTABLE_TYPE.SYNC;
    }
    if (this.editFlag.isProhibited) {
      immutableType = IMMUTABLE_TYPE.PROHIBITION_SALE;
    }
    if (this.isEditMode && !immutableType) {
      immutableType = IMMUTABLE_TYPE.UPDATE;
    }

    this.immutableFields = immutableFields(IMMUTABLE_TYPE.UPDATE, immutableType);
  }

  private iterateMaxBuyCountInfo(fn) {
    const purchasingQuantityInfo = this.salesInfo.maxBuyCountInfo;
    Object.keys(purchasingQuantityInfo).forEach(prop => fn(prop));
  }
}
